// City selector ordering: top markets pinned above the fold so members don't
// scroll for them. Static list by design (Kapil, Aug 2026); inclusion =
// booking/request volume OR a strong Preferred-restaurant presence, shown
// alphabetically for scannability.
export const PINNED_CITIES = [
  'Austin, TX',
  'Beverly Hills, CA',
  'Chicago, IL',
  'Houston, TX',
  'Indianapolis, IN',
  'Las Vegas, NV',
  'Miami, FL',
  'Miami Beach, FL',
  'Naples, FL',
  'Nashville, TN',
  'New York, NY',
  'Palm Beach, FL',
  'Scottsdale, AZ',
]

// Reorder a backend city list ({ text, value }[]) to:
// pinned cities (those present, in pinned order) → All Cities → rest A–Z
export function orderCities(cities) {
  if (!cities?.length) return cities || []

  const byValue = new Map(cities.map(c => [c.value, c]))
  const pinned = PINNED_CITIES.map(v => byValue.get(v)).filter(Boolean)
  const pinnedSet = new Set(PINNED_CITIES)
  const allCities = cities.filter(c => !c.value)
  const rest = cities
    .filter(c => c.value && !pinnedSet.has(c.value))
    .sort((a, b) => a.text.localeCompare(b.text))

  return [...pinned, ...allCities, ...rest]
}
